import { LogoutOutlined } from "@ant-design/icons";
import { Button, Tooltip } from "antd";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import logo from "../assets/images/logoGF.png";
import ConfirmationModal from "../components/modal/ConfirmationModal";
import { logout } from "../features/AuthSlice";
import { userDetails } from "../features/UserSlice";

function ProfileSetupLayout() {
  const [logoutModal, setLogoutModal] = useState(false);
  const firstLoginState = useSelector((state) => state.firstLoginState.value);
  const proHeight = document.body.clientHeight;
  let navigate = useNavigate();
  const dispatch = useDispatch();

  if (!firstLoginState) {
    return <Navigate to="/home" replace />;
  }

  function logoutNow() {
    // 🔑 NEW: Clear all filters on logout
    sessionStorage.removeItem('topPlansFilters');
    
    localStorage.setItem("authToken", "");
    localStorage.setItem("authUser", "");
    dispatch(logout());
    dispatch(userDetails({}));
    navigate("/login");
  }

  return (
    <>
      <div className="fixed flex w-full justify-between bg-white py-4 px-6 z-50 top-0 shadow">
        <div className="pri-font text-2xl">
          <img className="w-40" src={logo} alt="Logo" />
        </div>
        <Tooltip title={"Logout"}>
          <Button onClick={() => setLogoutModal(true)}>
            <LogoutOutlined />
          </Button>
        </Tooltip>
      </div>
      <div
        style={{ height: proHeight - 65 }}
        className="mt-16 px-6 pb-6 overflow-auto custom-scroll"
      >
        <Outlet />
      </div>
      <ConfirmationModal
        title="Logout"
        text="Are you sure want to logout?"
        handleCancel={() => setLogoutModal(false)}
        visible={logoutModal}
        handleOk={() => logoutNow()}
      />
    </>
  );
}

export default ProfileSetupLayout;
